export enum BillingAccountTypes {
  BUSINESS_CHECKING = 'Business Checking',
  BUSINESS_SAVINGS = 'Business Savings',
  CONSUMER_CHECKING = 'Consumer Checking',
  CONSUMER_SAVINGS = 'Consumer Savings',
}
